import { Card } from "antd";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCreditCard,
    faMoneyBillWave,
    faEnvelope,
    faBell,
    faUsers,
    faTicketAlt,
    faImage,
    faPercent,
} from "@fortawesome/free-solid-svg-icons";

const ACTIONS = [
    { label: "Thanh toán", path: "/payment/batch", icon: faCreditCard, bg: "bg-blue-50", color: "text-blue-600" },
    { label: "Rút tiền", path: "/withdraw", icon: faMoneyBillWave, bg: "bg-green-50", color: "text-green-600" },
    { label: "Email", path: "/email", icon: faEnvelope, bg: "bg-purple-50", color: "text-purple-600" },
    { label: "Push", path: "/push", icon: faBell, bg: "bg-orange-50", color: "text-orange-500" },
    { label: "Users", path: "/user", icon: faUsers, bg: "bg-cyan-50", color: "text-cyan-600" },
    { label: "Voucher", path: "/voucher", icon: faTicketAlt, bg: "bg-pink-50", color: "text-pink-600" },
    { label: "Banner", path: "/banner", icon: faImage, bg: "bg-indigo-50", color: "text-indigo-600" },
    { label: "Hoa hồng", path: "/commission", icon: faPercent, bg: "bg-yellow-50", color: "text-yellow-600" },
];

function DashboardQuickActions() {
    return (
        <Card title="Truy cập nhanh" className="shadow-sm">
            <div className="grid grid-cols-4 sm:grid-cols-8 gap-2">
                {ACTIONS.map((action) => (
                    <Link
                        key={action.path}
                        to={action.path}
                        className="flex flex-col items-center gap-2 p-3 rounded-xl hover:bg-surface-sunken transition-colors text-center no-underline"
                    >
                        <div className={`p-3 rounded-xl ${action.bg}`}>
                            <FontAwesomeIcon
                                icon={action.icon}
                                className={`text-lg ${action.color}`}
                            />
                        </div>
                        <span className="text-xs text-content-2 font-medium leading-tight">
                            {action.label}
                        </span>
                    </Link>
                ))}
            </div>
        </Card>
    );
}

export default DashboardQuickActions;
